import React, { useRef, useState } from 'react'

import { Row, Col, Popover, Typography, Icon } from 'antd'
import get from 'lodash/get'
import PT from 'prop-types'
import styled from 'styled-components'

import colors from '../../../../components/hocs/colors'
import errorService from '../../../../utils/analytics/error'
import { client } from '../../../../utils/graphql/configuration'
import { capitalize } from '../../../../utils/stringManipulation'
import { skillDescriptionQuery } from '../../GraduateOutcomes/gqlQueries'

const { Title, Paragraph } = Typography

const SkillTrigger = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  padding: 0;
  text-align: left;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  float: right;
  font-size: 16px;
  line-height: 1;
  padding: 0 0 0 8px;
`

export const SkillsBars = props => {
  const [skillDescription, setSkillDescription] = useState(null)
  const [popoverVisible, setPopoverVisible] = useState(false)
  const triggerRef = useRef(null)
  const { name: skillName = '' } = props

  const getSkillDescription = async skillName => {
    try {
      const result = await client.query({
        fetchPolicy: 'network-only',
        query: skillDescriptionQuery,
        variables: { skillName },
      })
      const description = get(result, 'data.skillDescription')
      setSkillDescription(description)
    } catch (error) {
      errorService.report(error, 'skillDescriptionQuery')
      console.log(error)
      setSkillDescription('Description Unavailable')
    }
  }

  const closePopover = () => {
    setPopoverVisible(false)
    if (triggerRef.current) triggerRef.current.focus()
  }

  const handleVisibleChange = (/** @type {boolean} */ visible) => {
    setPopoverVisible(visible)
    if (visible && !skillDescription) {
      getSkillDescription(skillName)
    }
    if (visible) {
      setTimeout(() => {
        const focusable = document.querySelector(
          '.ant-popover:not(.ant-popover-hidden) button, .ant-popover:not(.ant-popover-hidden) a',
        )
        if (focusable instanceof HTMLElement) focusable.focus()
      }, 150)
    }
  }

  return (
    <Row style={{ marginBottom: 10 }} className="horizontal-skill-bars">
      <Col md={6}>
        <div style={{ alignItems: 'center', display: 'flex', marginTop: 12 }}>
          <Popover
            placement="rightTop"
            visible={popoverVisible}
            trigger={/** @type {any} */ (['hover', 'click'])}
            title={
              <div
                style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}
              >
                <Title level={4} style={{ margin: 0 }}>
                  {capitalize(skillName)}
                  {'  '}
                  <a
                    href={`https://www.youtube.com/results?search_query=${skillName}`}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label={`Search "${capitalize(skillName)}" on YouTube`}
                  >
                    <Icon type="youtube" theme="filled" style={{ color: '#ff1800' }} aria-hidden />
                  </a>
                </Title>
                <CloseButton type="button" aria-label="Close" onClick={closePopover}>
                  <Icon type="close" aria-hidden />
                </CloseButton>
              </div>
            }
            content={
              <Paragraph className="skill-description-container" data-testid="skill-description">
                {skillDescription}
              </Paragraph>
            }
            onVisibleChange={handleVisibleChange}
            overlayStyle={{ width: 800 }}
          >
            <SkillTrigger
              ref={triggerRef}
              type="button"
              aria-label={`${capitalize(skillName)}: view skill description`}
              aria-expanded={popoverVisible}
              aria-haspopup="dialog"
            >
              {capitalize(skillName)}
            </SkillTrigger>
          </Popover>
        </div>
      </Col>
      {props.values.map((/** @type {any} */ child, /** @type {number} */ index) => (
        <Col key={`${get(child, 'value', 0)}${index}`} md={6} className="skill-bar-column">
          <div
            key={get(child, 'key')}
            style={{
              background: colors.gray4,
              borderRadius: 6,
              marginTop: 5,
            }}
          >
            <div
              role="progressbar"
              aria-label={`${capitalize(skillName)} ${capitalize(get(child, 'name', ''))}`}
              aria-valuenow={get(child, 'value', 0)}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuetext={`${get(child, 'value', 0)}%`}
              className="scale-bars-skills"
              style={{
                background: colors[get(child, 'name', '#fff')],
                borderColor: colors[get(child, 'name', '#fff')],
                borderRadius: 5,
                height: 15,
                minWidth: 10,
                opacity: 0.8,
                padding: '0 5px',
                width: `${get(child, 'value', 0)}%`,
              }}
            />
          </div>
        </Col>
      ))}
    </Row>
  )
}

SkillsBars.propTypes = {
  description: PT.string,
  name: PT.string,
  values: PT.array,
}

export default SkillsBars
